<tui-icon [icon]="icon" />

<div class="activity-row__information">
	@if (activity(); as activity) {
		<small>
			{{ activity.createdAt.toDate() | date: 'hh:mm aa' }}
		</small>
		<p
			class="font-size-medium"
			[innerHtml]="
				label() ?? 'activity.type.' + activity.type
					| transloco: { name: userName }
			"
		></p>
	}
</div>
